"use client";

import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useFormikContext } from "formik";
import { useState } from "react";

import { MDButton } from "@/components/atoms/MDButton";
import { SkuFormData } from "@/components/screens/ProductFormPage/types";
import { IKitComponentInput } from "@/interfaces/kit.interface";
import { KitTableMessages } from "@/messages/products/kit-table.messages";

interface Props {
  isVisible: boolean;
  onClose: () => void;
  messages: KitTableMessages;
  kit: IKitComponentInput;
}

const UpdateKitComponentDialog = ({ isVisible, onClose, messages, kit }: Props) => {
  const [quantity, setQuantity] = useState(kit.quantity || 0);
  const { values, setFieldValue } = useFormikContext<SkuFormData>();

  const onConfirm = async () => {
    const updatedKits = values.kitComponents.map((k) =>
      k.componentSkuId === kit.componentSkuId ? { ...k, quantity } : k
    );
    setFieldValue("kitComponents", updatedKits);
    onClose();
  };

  return (
    <Dialog open={isVisible} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{messages.updateKitDialogTitle}</DialogTitle>
      <DialogContent sx={{ overflowY: "visible" }}>
        <TextField
          label={messages.quantityLabel}
          value={quantity}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setQuantity(Number(e.target.value))}
          type="number"
          fullWidth
          slotProps={{
            htmlInput: { min: "0" },
            inputLabel: { shrink: true },
          }}
        />
      </DialogContent>
      <DialogActions>
        <MDButton variant="gradient" color="light" onClick={onClose}>
          {messages.cancelButton}
        </MDButton>
        <MDButton variant="gradient" color="dark" onClick={onConfirm}>
          {messages.updateButton}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateKitComponentDialog;
